<template>
  <Transition name="slide-fade">
    <section v-show="!isHidden" id="privacy" class="privacy">
      <div @click="closeModal" class="privacy__close">
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill=""
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#000"
            d="M1.954.04L22.46 20.546l-1.414 1.414L.54 1.454z"
          ></path>
          <path
            fill="#000"
            d="M.54 20.546L21.046.04l1.414 1.414L1.954 21.96z"
          ></path>
        </svg>
      </div>

      <div v-show="!isHidden" class="privacy__content">
        <h2>Согласие на обработку персональных данных ООО «Автобан Чери»</h2>

        <div class="privacy__content-item">
          <p>
            Настоящим я подтверждаю, что  ознакомлен с  Политикой об обработке
            персональных данных ООО «Автобан Чери» ИНН 6679154153 ( далее
            «Оператор»)  и даю Оператору согласие:<br />
            на обработку (любое действие (операцию) или совокупность действий
            (операций), совершаемых с использованием средств автоматизации
            (автоматизированная обработка) или без использования таких средств
            (неавтоматизированная обработка) персональных данных, таких как:
          </p>
          <ul>
            <li>ФИО (в т.ч. по отдельности, в т.ч. прежние);</li>
            <li>
              реквизиты документа, удостоверяющего личность, и иных
              представленных субъектом персональных данных документов,
              гражданство;
            </li>
            <li>дата рождения;</li>
            <li>место рождения;</li>
            <li>адрес регистрации;</li>
            <li>адрес фактического места жительства;</li>
            <li>семейное, социальное, имущественное положение;</li>
            <li>
              любая контактная информация, в т.ч. номер телефона, адрес
              электронной почты (E-mail), ссылка на персональный сайт и профиль
              в соцсетях;
            </li>
            <li>
              данные о профессии, месте работы, должности, образовании и
              доходах, другая персональная информация;
            </li>
            <li>
              любая иная информация, относящаяся к личности субъекта
              персональных данных, а именно, на совершаемые Оператором действия,
              предусмотренные п. 3 ч. 1 ст. 3 Федерального закона от 27.07.2006
              N 152-ФЗ "О персональных данных", включая сбор, запись,
              систематизацию, накопление, хранение, уточнение (обновление,
              изменение), извлечение, использование, обезличивание,
              блокирование, удаление, уничтожение, передачу (распространение,
              предоставление, доступ) указанных персональных данных третьим
              лицам, а также осуществление любых иных действий с персональными
              данными субъекта персональных данных с учетом действующего
              законодательства, с соблюдением мер, обеспечивающих защиту
              персональных данных от несанкционированного доступа, в объеме,
              необходимом для достижения целей настоящего Согласия.
            </li>
          </ul>
          <p>с целью:</p>
          <ul>
            <li>- определения потребностей в производственной мощности;</li>
            <li>
              - мониторинга исполнения сервисными центрами гарантийной политики;
            </li>
            <li>- ведения истории обращения в сервисные центры;</li>
            <li>
              - проведения Оператором и его уполномоченными лицами и
              контрагентами маркетинговых исследований в области продаж,
              сервиса, послепродажного обслуживания;
            </li>
            <li>
              - направления мне уведомлений, информационных сообщений, рекламных
              материалов.
            </li>
            <li>- и иных.</li>
          </ul>
          <p>Настоящим субъект персональных данных подтверждает:</p>
          <ul>
            <li>- что все указанные им данные принадлежат лично ему;</li>
            <li>
              - и признает, что им внимательно в полном объеме прочитано
              настоящее Согласие и условия обработки его персональных данных,
              текст согласия и условия обработки персональных данных ему
              понятны;
            </li>
            <li>
              - свое согласие Оператору на получение информационной рассылки о
              новостях Сайтов, в том числе анонсов статей, размещенных на Сайтах
              и рекламных материалов, рекламы продуктов Оператора, рекламы
              продуктов партнеров Оператора и совместных продуктов Оператора и
              его партнеров, в том числе, но не ограничиваясь, по почте,
              телефону, электронной почте;
            </li>
            <li>
              - дачу согласия на передачу своих персональных данных партнерам и
              клиентам Оператора по организации совместных мероприятий,
              совместному исполнению обязательств по договорам и т.д.;
            </li>
            <li>
              - и выражает согласие с настоящими условиями обработки
              персональных данных.
            </li>
          </ul>
          <p>
            Оператор (Автоцентр) ведет деятельность на территории Российской
            Федерации в соответствии с законодательством Российской Федерации.
            Предлагаемые товары/работы/услуги доступны к получению на территории
            Российской Федерации. Я подтверждаю, что давая настоящее согласие на
            обработку моих вышеуказанных персональных данных, я нахожусь на
            территории Российской Федерации
          </p>
          <p>
            <b>
              Настоящее согласие действует бессрочно с момента предоставления
              данных.
            </b>
            Указанное согласие может быть отозвано путем подачи заявления с
            указанием данных, определенных ст. 14 Закона «О персональных данных»
            путем направления соответствующего письменного заявления Оператору
            по адресу 623700, Свердловская область, г. Екатеринбург, Щербакова,
            144.
          </p>
          <p>
            Настоящее согласие признается исполненным в простой письменной
            форме.
          </p>
        </div>
      </div>
    </section>
  </Transition>
</template>

<script>
export default {
  data() {
    return {
      isHidden: true,
    };
  },
  methods: {
    closeModal() {
      this.isHidden = true;
    },
  },
  mounted() {
    this.emitter.on("open-agree-processing", (data) => {
      this.isHidden = data.open;
    });
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
